const doc = [({"en":({"js":({"admin":({"roles":({"show":({"the_role_was_deleted":"The role was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;